import { Service } from '@toeverything/infra';

import { WorkspaceQuota } from '../entities/quota';
import { QuotaCheckDialog } from '../entities/quota-check-dialog';

export class WorkspaceQuotaService extends Service {
  quota = this.framework.createEntity(WorkspaceQuota);
  dialog = this.framework.createEntity(QuotaCheckDialog);

  override dispose(): void {
    this.quota.dispose();
    this.dialog.dispose();
  }
}
